import { useAsyncEffect, useNotifications, useRouter } from "@relode/core";
import qs from "qs";

import { ClientPublicJobActions } from "./clientPublicJobActions";
import { ClientPublicJobState } from "./clientPublicJobState";

export const useClientPublicJobHandlers = (
    state: ClientPublicJobState,
    actions: ClientPublicJobActions
) => {
    const {
        location: { search },
    } = useRouter();
    const { actions: notifications } = useNotifications();

    useAsyncEffect(async () => {
        const queryString = qs.parse(search, { ignoreQueryPrefix: true });
        if (
            queryString &&
            Object.keys(queryString).length > 0 &&
            queryString.token
        ) {
            await actions.loadJob(queryString.token as string);
        } else {
            notifications.showArea(
                "info",
                "Currently you can view a specific job only by clicking the link from your email.",
                "loadJob",
                {
                    canClose: false,
                }
            );
        }
    }, []);
};
